import { GENERAL_STATUSES } from '../../shared/constants/general.status.constants';

// PaymentInstrumentTypes, metadata code 34
export var DIRECT_DEBIT = '8';
export var DD_SUB_TYPE_NETHERLANDS = '3';
var ACP = '14';
var BRAINTREE = '17';
var CHECK_REFUND = '19';
var CONVERGENT_BILLER_INVOICE = '15';
var CREDIT_CARD = '0';
var CURRENCY_ENTITLEMENT = '21';
var E_CHECK = '1';
var EXTERNAL_BILL = '4'; //potentially these constants may be duplicates of src/components/search/search.constants.js
var EXTERNAL_GIFT_CARD = '10';
var GOOGLE_PLAY = '12';
var INTERNAL_GIFT_CARD = '3';
var ITUNES = '6';
var PAY_PAL = '5';
var ROKU = '11';
var STORED_VALUE_ACCOUNT = '2';
var UWP = '16';
var XBOX = '9';
var STRIPE_ACCOUNT = '22';

// only these payment instrument types are supported in Invision at this time
export var SUPPORTED_PAYMENT_INSTRUMENT_TYPES = {
  ACP: ACP,
  BRAINTREE: BRAINTREE,
  CREDIT_CARD: CREDIT_CARD,
  CURRENCY_ENTITLEMENT: CURRENCY_ENTITLEMENT,
  DIRECT_DEBIT: DIRECT_DEBIT,
  E_CHECK: E_CHECK,
  EXTERNAL_BILL: EXTERNAL_BILL,
  EXTERNAL_GIFT_CARD: EXTERNAL_GIFT_CARD,
  GOOGLE_PLAY: GOOGLE_PLAY,
  INTERNAL_GIFT_CARD: INTERNAL_GIFT_CARD,
  ITUNES: ITUNES,
  PAY_PAL: PAY_PAL,
  ROKU: ROKU,
  STORED_VALUE_ACCOUNT: STORED_VALUE_ACCOUNT,
  STRIPE_ACCOUNT: STRIPE_ACCOUNT,
  CHECK_REFUND: CHECK_REFUND
};
export var SUPPORTED_OTT_PAYMENT_INSTRUMENT_TYPES = Object.assign({}, {
  CONVERGENT_BILLER_INVOICE: CONVERGENT_BILLER_INVOICE
}, SUPPORTED_PAYMENT_INSTRUMENT_TYPES);

// Ideally the values here should be returned from the API
export var PAYMENT_INSTRUMENT_ALWAYS_REQUIRED_ADDRESS = {
  CREDIT_CARD: CREDIT_CARD,
  E_CHECK: E_CHECK
};

// Ideally the values here should be returned from the API
export var PAYMENT_INSTRUMENT_NEVER_REQUIRED_ADDRESS = {
  INTERNAL_GIFT_CARD: INTERNAL_GIFT_CARD
};
export var DEFAULT_UNKNOWN_PAYMENT_METHOD_TYPE_SORT_ORDER = 999;
/**
 * @see https://jira.csgicorp.com/browse/ASC-50330
 */
export var PAYMENT_METHOD_TYPE_SORT_ORDER = [CREDIT_CARD, DIRECT_DEBIT, INTERNAL_GIFT_CARD, EXTERNAL_GIFT_CARD, EXTERNAL_BILL, ACP, E_CHECK, STORED_VALUE_ACCOUNT, PAY_PAL, BRAINTREE, ITUNES, GOOGLE_PLAY,
// FACEBOOK,
ROKU, XBOX, UWP];

// only these payment instrument types can be created in Invision at this time
export var CREATABLE_PAYMENT_INSTRUMENT_TYPES = {
  CREDIT_CARD: CREDIT_CARD,
  EXTERNAL_BILL: EXTERNAL_BILL,
  EXTERNAL_GIFT_CARD: EXTERNAL_GIFT_CARD,
  INTERNAL_GIFT_CARD: INTERNAL_GIFT_CARD,
  E_CHECK: E_CHECK
};

// all payment instrument types (except the opt'd ones) can be edited in Invision at this time
export var EDITABLE_PAYMENT_INSTRUMENT_TYPES = {
  CREDIT_CARD: CREDIT_CARD,
  EXTERNAL_BILL: EXTERNAL_BILL,
  EXTERNAL_GIFT_CARD: EXTERNAL_GIFT_CARD,
  E_CHECK: E_CHECK
};
export var OPT_OUT_PROCESS_CREDIT_PAYMENT_SELECTION = {
  DIRECT_DEBIT: DIRECT_DEBIT,
  BRAINTREE: BRAINTREE
};
export var ALWAYS_ABLE_TO_SET_AS_DEFAULT_TYPES = {
  DIRECT_DEBIT: DIRECT_DEBIT
};
export var READ_ONLY_PAYMENT_INSTRUMENT_TYPES_EXCEPTIONS = {
  DIRECT_DEBIT: DIRECT_DEBIT
};

// opt-out UI support for reactivation
export var OPT_OUT_REACTIVATE_PAYMENT_INSTRUMENT_TYPES = {
  BRAINTREE: BRAINTREE,
  PAY_PAL: PAY_PAL
};
export var AUTO_PAY_SUPPORTED_PAYMENT_INSTRUMENT_TYPES = {
  CREDIT_CARD: CREDIT_CARD,
  E_CHECK: E_CHECK
};
export var PAYMENT_METHOD_STATUSES = GENERAL_STATUSES;
export var REMOVE_PAYMENT_METHOD_OPTION_ID = 'REMOVE_PAYMENT_METHOD_OPTION_ID';
export var ANONYMIZE_PAYMENT_METHOD_OPTION_ID = 'ANONYMIZE_PAYMENT_METHOD_OPTION_ID';
export var REACTIVATE_PAYMENT_METHOD_OPTION_ID = 'REACTIVATE_PAYMENT_METHOD_OPTION_ID';
export var SET_AS_DEFAULT_PAYMENT_METHOD_OPTION_ID = 'SET_AS_DEFAULT_PAYMENT_METHOD_OPTION_ID';
export var ADD_TO_BLOCKLIST_MENU_ID = 'ADD_TO_BLOCKLIST';
export var ADD_TO_ALLOWLIST_MENU_ID = 'ADD_TO_ALLOWLIST';
export var REMOVE_FROM_BLOCKLIST_MENU_ID = 'REMOVE_FROM_BLOCKLIST';
export var REMOVE_FROM_ALLOWLIST_MENU_ID = 'REMOVE_FROM_ALLOWLIST';
export var VIEW_TRANSACTION_HISTORY_MENU_ID = 'VIEW_TRANSACTION_HISTORY';
export var ENABLE_ACCOUNT_NUMBER_KEY = 'enable_account_number';
export var IS_TWO_STEP_PAYMENT_KEY = 'is_two_step_payment';